import { render, staticRenderFns } from "./CopyStakeStatsStreamersModal.vue?vue&type=template&id=ae2bd380&scoped=true&lang=pug"
import script from "./CopyStakeStatsStreamersModal.vue?vue&type=script&lang=ts"
export * from "./CopyStakeStatsStreamersModal.vue?vue&type=script&lang=ts"
import style0 from "./CopyStakeStatsStreamersModal.vue?vue&type=style&index=0&id=ae2bd380&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae2bd380",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
